import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Eyebrow, Section } from './Section';
import { CtaButton } from './CtaButton';
import { tomeInclusions, tomes } from '../data/tomes';
export function Tomes() {
  return <Section tone="paper" labelledBy="tomes-title" data-id="element-249" data-mp="1tz7eklxkq01n">
      <Eyebrow data-id="element-250" data-mp="1p15txwki1so2">Le contenu, tome par tome</Eyebrow>
      <h2 id="tomes-title" className="max-w-3xl font-serif text-3xl font-semibold leading-[1.15] text-graphite md:text-[2.75rem]" data-id="element-251" data-mp="1p0e7pccsl7ag">
        Six tomes. Un parcours complet. Plus d’improvisation.
      </h2>

      <ol className="mt-16 border-t border-warm-line" data-id="element-252" data-mp="1g2kdq82i2pqg">
        {tomes.map(tome => <li key={tome.number} className="grid grid-cols-1 gap-6 border-b border-warm-line py-10 md:grid-cols-12 md:gap-10" data-id="element-253" data-mp="1b1myo4csebt6">
            <div className="md:col-span-3" data-id="element-254" data-mp="35fnxip8c6yt9">
              <p className="font-serif text-4xl font-semibold leading-none text-warm-light" data-id="element-255" data-mp="35dbfyd6hqqgq">
                {tome.number}
              </p>
              <p className="mt-3 text-xs uppercase tracking-[0.14em] text-warm" data-id="element-256" data-mp="27gdycogcx4rx">
                {tome.fiches}
              </p>
              {tome.decisive && <p className="mt-3 inline-flex items-center gap-2 border border-graphite px-2.5 py-1 text-[0.68rem] font-semibold uppercase tracking-[0.12em] text-graphite" data-id="element-257" data-mp="2cdxczpgyvjke">
                  Le passage décisif
                </p>}
            </div>

            <div className="md:col-span-9" data-id="element-258" data-mp="2q8pvmws5lfv7">
              <h3 className="font-serif text-2xl font-semibold leading-snug text-graphite md:text-[1.75rem]" data-id="element-259" data-mp="2v6i0erdwcwgt">
                {tome.title}
              </h3>
              <p className="mt-2 text-sm text-warm" data-id="element-260" data-mp="2ggtutdyonbna">{tome.subtitle}</p>
              <p className="mt-5 max-w-prose text-base leading-relaxed text-graphite-mid" data-id="element-261" data-mp="2lfwsueg8whlr">
                {tome.body}
              </p>
              <p className="mt-6 flex gap-3 text-base leading-relaxed text-graphite" data-id="element-262" data-mp="394ppkd4oythf">
                <span aria-hidden="true" className="text-warm-light" data-id="element-263" data-mp="3dxrab1rkxn8x">
                  →
                </span>
                <span className="font-medium" data-id="element-264" data-mp="3ns6mzwg0jgh9">{tome.promise}</span>
              </p>
            </div>
          </li>)}
      </ol>

      <div className="mt-14 grid grid-cols-1 gap-10 border border-warm-line bg-creme p-8 md:grid-cols-12 md:p-10" data-id="element-265" data-mp="3es9v7lybu1hz">
        <h3 className="font-serif text-2xl font-semibold text-graphite md:col-span-4" data-id="element-266" data-mp="39tq6jdscmblx">
          Dans chaque tome
        </h3>
        <ul className="space-y-4 md:col-span-8" data-id="element-267" data-mp="34uvpaga14v3x">
          {tomeInclusions.map(item => <li key={item} className="flex gap-3 text-base text-graphite-mid" data-id="element-268" data-mp="302c7t8881ftu">
              <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-graphite" aria-hidden="true" data-id="element-269" data-mp="2v3sjx2a2htyu" />
              <span data-id="element-270" data-mp="2r4jug9m28i93">{item}</span>
            </li>)}
        </ul>
      </div>

      <div className="mt-14" data-id="element-271" data-mp="2m2b0b9xgba5e">
        <CtaButton size="sm" data-id="element-272" data-mp="2m5p4mnpodtfh">Je veux le système complet</CtaButton>
      </div>
    </Section>;
}